import 'hammerjs';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgApexchartsModule } from 'ng-apexcharts';
import { httpLoaderFactory } from './app/services/httpLoaderFactory.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularMaterialModule } from './app/angular-material.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CustomHttpInterceptor } from './app/customizations/custom-http-interceptor';
import { AuthInterceptor } from './app/core/auth-interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { PaginationCustomization } from './app/customizations/pagination-customization';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomDatetimeAdapter } from './app/customizations/custom-datetime-adapter';
import { CustomDateAdapter, CUSTOM_DATE_FORMATS } from './app/customizations/custom-date-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { TranslateDatePipe } from './app/pipes/translate-date.pipe';
import { DeviceModelDisplayPipe } from './app/pipes/device-model-display.pipe';
import { ExtensionDisplayPipe } from './app/pipes/extension-display.pipe';
import { DatePipe, CommonModule, registerLocaleData, JsonPipe } from '@angular/common';
import { TokenStorage } from './app/core/token-storage';
import { UsersService } from './app/services/users.service';
import { OrganizationsService } from './app/services/organizations.service';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { MatChipsModule } from '@angular/material/chips';
import { NgxMatDateAdapter } from '@ngxmc/datetime-picker';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEn, 'en');

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            AngularMaterialModule,
            FontAwesomeModule,
            AppRoutingModule,
            ReactiveFormsModule,
            FormsModule,
            CommonModule,
            NgxSpinnerModule,
            ToastrModule.forRoot(),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: httpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
            NgApexchartsModule,
            MatProgressBarModule,
            MatSlideToggleModule,
            MatTreeModule,
            MatChipsModule
        ),
        OrganizationsService,
        UsersService,
        TokenStorage,
        DatePipe,
        JsonPipe,
        ExtensionDisplayPipe,
        DeviceModelDisplayPipe,
        TranslateDatePipe,
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
        { provide: NgxMatDateAdapter, useClass: CustomDatetimeAdapter },
        { provide: MatPaginatorIntl, useClass: PaginationCustomization },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ],
}).catch((err) => console.log(err));
